import MyQueries from "./MyQueries";

export default MyQueries;